
import React from "react";
import { User } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

interface UserRole {
  id: string;
  user_id: string;
  email: string;
  full_name: string | null;
  role: string;
  created_at: string;
}

interface UserRolesTableProps {
  userRoles: UserRole[];
  loading: boolean;
}

export const UserRolesTable = ({ userRoles, loading }: UserRolesTableProps) => {
  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <User className="h-5 w-5" />
          User Roles
        </CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <p>Loading user roles...</p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>User</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Role</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {userRoles.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3} className="text-center py-4">
                    No user roles found
                  </TableCell>
                </TableRow>
              ) : (
                userRoles.map((role, index) => (
                  <TableRow key={index}>
                    <TableCell>{role.full_name || 'Unnamed User'}</TableCell>
                    <TableCell>{role.email}</TableCell>
                    <TableCell>
                      <Badge 
                        variant={role.role === 'admin' ? 'destructive' : 'secondary'}
                        className="capitalize"
                      >
                        {role.role}
                      </Badge>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};
